import { render, staticRenderFns } from "./ParamOcorrenciaDestinoForm.vue?vue&type=template&id=568d3d39"
import script from "./ParamOcorrenciaDestinoForm.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaDestinoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports